const fmt = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 });

export const Ticker = ({ opportunities = [] }) => {
  if (opportunities.length === 0) return null;
  const items = opportunities.slice(0, 24);
  const row = [...items, ...items];
  return (
    <div data-testid="market-ticker" className="relative overflow-hidden border-y border-[#6D28D9]/15 bg-[#FAF9FF] py-4">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {row.map((o, i) => {
          const down = o.change_pct < 0;
          return (
            <span key={`${o.slug}-${i}`} data-testid={i < items.length ? `ticker-item-${o.slug}` : undefined} className="mx-6 flex items-center gap-3 font-mono2 text-[11px] uppercase tracking-[0.2em]">
              <span className="text-slate-500">{o.name}</span>
              <span className="text-slate-700">₹{fmt.format(o.price)}</span>
              <span className={down ? "text-rose-600" : "text-emerald-600"}>{typeof o.change_pct === "number" ? `${down ? "" : "+"}${o.change_pct}%` : "—"}</span>
              <span className="ml-6 h-1 w-1 rotate-45 bg-[#6D28D9]/50" />
            </span>
          );
        })}
      </div>
    </div>
  );
};
